export { default as Installments } from './Installments';
